import g from "./design-system.es58.js";
import x from "./design-system.es87.js";
import { resolveComponent as k, openBlock as l, createElementBlock as o, withDirectives as w, createElementVNode as s, renderSlot as p, vShow as h, createTextVNode as i, normalizeClass as c, createVNode as m, createCommentVNode as b, normalizeStyle as v, Fragment as C, renderList as I } from "vue";
/* empty css                    */
import V from "./design-system.es128.js";
const B = {
  name: "DsHtmlPreview",
  components: {
    Icon: g,
    Placeholder: x
  },
  props: {
    html: String,
    hideHeader: Boolean,
    loading: Boolean,
    interceptIframeClicks: Boolean,
    /**
     * The sandbox attribute which is used by the iframe.
     */
    sandbox: {
      type: String,
      default: "allow-scripts allow-popups"
    }
  },
  emits: ["click"],
  data() {
    return {
      view: "desktop",
      short: [{ height: ".5rem", boxes: [1] }],
      medium: [{ height: "0.8rem", boxes: [1] }],
      tall: [{ height: "1.25rem", boxes: [1] }]
    };
  },
  computed: {
    isDesktop() {
      return this.view === "desktop";
    },
    isMobile() {
      return this.view === "mobile";
    }
  },
  methods: {
    random(r, e) {
      return Math.floor(Math.random() * (e - r + 1)) + r;
    },
    setView(r) {
      this.view = r;
    },
    onClickIframeClickInterceptor() {
      this.$emit("click");
    }
  }
}, P = { class: "html-preview" }, S = { key: 0 }, D = { class: "phone" }, H = {
  key: 0,
  class: "frame placeholder"
}, M = ["srcdoc", "sandbox"];
function N(r, e, n, z, a, t) {
  const f = k("Icon"), u = k("Placeholder");
  return l(), o("div", P, [
    n.hideHeader ? b("", !0) : (l(), o("header", S, [
      w(s("div", null, [
        p(r.$slots, "left", {}, void 0, !0)
      ], 512), [
        [h, r.$slots.left]
      ]),
      e[4] || (e[4] = i()),
      s("div", {
        class: c({ center: !r.$slots.left })
      }, [
        m(f, {
          class: c(["desktop", { active: t.isDesktop }]),
          name: "view-desktop",
          onClick: e[0] || (e[0] = (d) => t.setView("desktop"))
        }, null, 8, ["class"]),
        e[3] || (e[3] = i()),
        m(f, {
          class: c({ active: t.isMobile }),
          name: "view-mobile",
          onClick: e[1] || (e[1] = (d) => t.setView("mobile"))
        }, null, 8, ["class"])
      ], 2)
    ])),
    e[8] || (e[8] = i()),
    w(s("div", null, [
      p(r.$slots, "context", {}, void 0, !0)
    ], 512), [
      [h, r.$slots.context]
    ]),
    e[9] || (e[9] = i()),
    s("div", {
      class: c(["iframe-wrapper", a.view])
    }, [
      s("div", D, [
        n.loading ? (l(), o("div", H, [
          s("div", {
            class: "title",
            style: v({ width: `${t.random(30, 50)}%` })
          }, [
            m(u, { rows: a.tall }, null, 8, ["rows"])
          ], 4),
          e[6] || (e[6] = i()),
          (l(!0), o(C, null, I(t.random(4, 8), (d) => (l(), o("div", {
            key: d,
            class: "section"
          }, [
            s("div", {
              class: "sub-title",
              style: v({ width: `${t.random(25, 35)}%` })
            }, [
              m(u, { rows: a.medium }, null, 8, ["rows"])
            ], 4),
            e[5] || (e[5] = i()),
            (l(!0), o(C, null, I(t.random(4, 6), (y) => (l(), o("div", {
              key: y,
              class: "content",
              style: v({ width: `${t.random(90, 100)}%` })
            }, [
              m(u, { rows: a.short }, null, 8, ["rows"])
            ], 4))), 128))
          ]))), 128))
        ])) : (l(), o("iframe", {
          key: 1,
          ref: "frame",
          class: "frame",
          srcdoc: n.html,
          sandbox: n.sandbox,
          frameborder: "0"
        }, null, 8, M)),
        e[7] || (e[7] = i()),
        n.interceptIframeClicks ? (l(), o("div", {
          key: 2,
          class: "iframe-click-interceptor",
          onClick: e[2] || (e[2] = (...d) => t.onClickIframeClickInterceptor && t.onClickIframeClickInterceptor(...d))
        })) : b("", !0)
      ])
    ], 2)
  ]);
}
const q = /* @__PURE__ */ V(B, [["render", N], ["__scopeId", "data-v-6478c9bd"]]);
export {
  q as default
};
//# sourceMappingURL=design-system.es57.js.map
